export type TrafficSource = "paid_ads" | "organic";

export interface LeadTrackingData {
    trafficSource: TrafficSource;
    trafficSourceLabel: "Paid Ads" | "Organic";
    landingPageUrl: string;
    currentPageUrl: string;
    referrer: string;
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;
    utmContent: string;
    utmTerm: string;
}

const STORAGE_KEY = "kd_lead_tracking";

function getUtmValue(params: URLSearchParams, key: string) {
    return params.get(key)?.trim() || "";
}

function isPaidAdsMedium(utmMedium: string) {
    return utmMedium.toLowerCase() === "cpc";
}

function buildTrackingData(url: URL, referrer: string): LeadTrackingData {
    const utmMedium = getUtmValue(url.searchParams, "utm_medium");
    const trafficSource = isPaidAdsMedium(utmMedium) ? "paid_ads" : "organic";

    return {
        trafficSource,
        trafficSourceLabel: trafficSource === "paid_ads" ? "Paid Ads" : "Organic",
        landingPageUrl: url.href,
        currentPageUrl: url.href,
        referrer,
        utmSource: getUtmValue(url.searchParams, "utm_source"),
        utmMedium,
        utmCampaign: getUtmValue(url.searchParams, "utm_campaign"),
        utmContent: getUtmValue(url.searchParams, "utm_content"),
        utmTerm: getUtmValue(url.searchParams, "utm_term"),
    };
}

export function getLeadTrackingData(): LeadTrackingData {
    if (typeof window === "undefined") {
        return {
            trafficSource: "organic",
            trafficSourceLabel: "Organic",
            landingPageUrl: "",
            currentPageUrl: "",
            referrer: "",
            utmSource: "",
            utmMedium: "",
            utmCampaign: "",
            utmContent: "",
            utmTerm: "",
        };
    }

    const currentUrl = new URL(window.location.href);
    const currentTracking = buildTrackingData(currentUrl, document.referrer);

    try {
        const storedTracking = window.sessionStorage.getItem(STORAGE_KEY);
        const parsedTracking = storedTracking
            ? (JSON.parse(storedTracking) as LeadTrackingData)
            : null;

        if (currentTracking.trafficSource === "paid_ads" || !parsedTracking) {
            window.sessionStorage.setItem(
                STORAGE_KEY,
                JSON.stringify(currentTracking),
            );
            return currentTracking;
        }

        const mergedTracking = {
            ...parsedTracking,
            currentPageUrl: currentTracking.currentPageUrl,
        };

        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(mergedTracking));
        return mergedTracking;
    } catch {
        return currentTracking;
    }
}
